/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      include: [] // 存储需要缓存的组件名

    };
  },
  created: function created() {
    var _this = this;

    // 通过监听hashchange事件 判断当前页面的路由与实际的路由是否一致
    window.addEventListener('hashchange', function () {
      var currPath = window.location.hash.slice(1);

      if (_this.$route.path !== currPath) {
        // 不一致就跳转url的路由
        _this.$router.push(currPath);
      }
    }, false);
  },
  watch: {
    $route: function $route(to, from) {
      // 需要缓存的页面加入缓存
      if (to.meta.keepAlive) {
        !this.include.includes(to.name) && this.include.push(to.name);
      } // 删除缓存


      if (from.meta.keepAlive && (to.meta.deepth <= from.meta.deepth || !to.meta.deepth)) {
        var index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }
    }
  }
};